import { isContextoPrincipal } from '../common/contexto-utils';

export default function SistemaContextoManager(
  $q,
  $rootScope,
  acessoService,
  acessoContextoHolder,
  entidadeContextoHolderService,
  userAccessContext,
  appContextoService
) {
  const getApplicationContext = () => {
    return 'SistemaContextoHolderService';
  };

  const resolve = (idSistema) => {
    const contextoAtual = entidadeContextoHolderService.getObject();

    return acessoService.getSistemasByEntidade(contextoAtual.values.entity).then((sistemas) => {
      const sistema = _.find(sistemas, sistema => sistema.id == idSistema);
      if (!sistema) {
        return $q.reject();
      }

      return acessoService.meusAcessos().then((acessos) => {
        const acessoSistema = findAcessoSistema(acessos, sistema.id, contextoAtual.values.entity);
        if (!acessoSistema) {
          return $q.reject();
        }

        $rootScope.$emit('gerenciador.acessos.sistema.selecionado', { sistema: sistema });
        acessoContextoHolder.put(acessos);

        return sistema;
      });
    });
  };

  const activateUserAccess = (sistemaSelecionado) => {
    const contextoAtual = entidadeContextoHolderService.getObject();
    if (!sistemaSelecionado) {
      return $q.reject();
    }

    const acessoSistemaSelecionado = findAcessoSistema(
      acessoContextoHolder.get(),
      sistemaSelecionado.id,
      contextoAtual.values.entity,
    );

    if (!acessoSistemaSelecionado) {
      return $q.reject();
    }

    userAccessContext.setUserAccess(acessoSistemaSelecionado);
    appContextoService.setAppContext(acessoSistemaSelecionado);

    if (sistemaSelecionado.urlSubcontext && isContextoPrincipal(acessoSistemaSelecionado.values)) {
      $rootScope.$emit('gerenciador.acessos.subcontexto.selecionado', {
        subcontexto: { value: '0' }
      });
    }

    return $q.resolve(acessoSistemaSelecionado);
  };

  const findAcessoSistema = (acessos, sistema, entidade) =>
    _.find(acessos, acesso =>
      acesso.system == sistema
      && acesso.values.entity == entidade
      && isContextoPrincipal(acesso.values)
    ) || _.find(acessos, acesso =>
      acesso.system == sistema && acesso.values.entity == entidade
    );

  return {
    getApplicationContext: getApplicationContext,
    resolve: resolve,
    activateUserAccess: activateUserAccess,
  }
}

SistemaContextoManager.$inject = [
  '$q',
  '$rootScope',
  'AcessoService',
  'AcessoContextoHolderService',
  'EntidadeContextoHolderService',
  'UserAccessContext',
  'AppContextService'
];
